import React from "react";
import { convertRupeesToWords } from "../../../../Components/Functions/amt.fun";

const SalaryBreakDown = ({ attendanceData }) => {
  let netPay = attendanceData?.paybleSalary?.toFixed(2);
  let salaryPerMonth = 0;
  let incentive = 0;
  let payableSalary = 0;
  let ptDeduction = 0;
  let otherDeduction = 0;
  let salaryAdjust = 0;
  let Arrears = 0;

  if (attendanceData?.salaryData?.salaryPerMonth) {
    salaryPerMonth = Number(attendanceData?.salaryData?.salaryPerMonth ?? 0);
    incentive = Number(attendanceData?.incentiveEmployee ?? 0);
    payableSalary = Number(attendanceData?.paybleSalary ?? 0);
    ptDeduction = Number(attendanceData?.salaryData?.ptDeductionPerMonth ?? 0);
    otherDeduction =
      Number(attendanceData?.salaryData?.deduction ?? 0) + ptDeduction;
    salaryAdjust = salaryPerMonth + incentive - payableSalary - otherDeduction;
    if (salaryAdjust < 0) {
      Arrears = salaryAdjust * -1;
      salaryAdjust = 0;
    }
  } else {
    salaryPerMonth = Number(attendanceData?.employeeData?.salaryPerMonth ?? 0);
    incentive = Number(attendanceData?.incentiveEmployee ?? 0);
    payableSalary = Number(attendanceData?.paybleSalary ?? 0);
    ptDeduction = Number(attendanceData?.employeeData?.pfptDeduction ?? 0);
    otherDeduction = Number(attendanceData?.employeeData?.pfptDeduction ?? 0);

    salaryAdjust = salaryPerMonth + incentive - payableSalary - otherDeduction;
    if (salaryAdjust < 0) {
      Arrears = salaryAdjust * -1;
      salaryAdjust = 0;
    }
  }
  return (
    <div>
      <div className="row justify-content-between">
        <div className="col-sm-6">
          <table className="table table-borderless">
            <thead>
              <tr style={{ backgroundColor: "rgba(187, 174, 181, 0.16)" }}>
                <th
                  style={{
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Earnings
                </th>
                <th
                  style={{
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Basic</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{(salaryPerMonth * 0.5)?.toFixed(2)}
                </td>
                {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>House Rent Allowance</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{(salaryPerMonth * 0.25)?.toFixed(2)}
                </td>
                {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Transport Allowance</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{(salaryPerMonth * 0.06)?.toFixed(2)}
                </td>
                {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Fixed Allowance</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{(salaryPerMonth * 0.19)?.toFixed(2)}
                </td>
                {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Incentive</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{incentive?.toFixed(2) || "0"}
                </td>
                {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
              </tr>
              {Arrears > 0 && (
                <tr>
                  <td style={{ paddingBottom: "0px" }}>Arrears</td>
                  <td style={{ paddingBottom: "0px" }}>
                    ₹{Arrears?.toFixed(2) || "0"}
                  </td>
                  {/* <td style={{ paddingBottom: "0px" }}>-</td> */}
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <th>Gross Earnings</th>
                <th>₹{(salaryPerMonth + incentive + Arrears).toFixed(2)}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="col-sm-5">
          <table className="table table-borderless">
            <thead>
              <tr style={{ backgroundColor: "rgba(187, 174, 181, 0.16)" }}>
                <th
                  style={{
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Deductions
                </th>
                <th
                  style={{
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  Amount
                </th>
                {/* <th
                  style={{
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: "bold",
                  }}
                >
                  YTD
                </th> */}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Professional Tax</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{ptDeduction?.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Provident Fund</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹
                  {Number(
                    attendanceData?.salaryData?.pfDeductionPerMonth ?? 0
                  ).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>ESIC</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹
                  {(
                    Number(
                      attendanceData?.salaryData?.esicEmployeePerMonth ?? 0
                    ) +
                    Number(
                      attendanceData?.salaryData?.esicEmployerPerMonth ?? 0
                    )
                  ).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>TDS</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹
                  {(
                    Number(attendanceData?.salaryData?.tdsPerYear ?? 0) / 12
                  ).toFixed(2)}
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: "0px" }}>Prerequsites</td>
                <td style={{ paddingBottom: "0px" }}>
                  ₹{salaryAdjust?.toFixed(2)}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th>Total Deductions</th>
                <th>₹{(otherDeduction + salaryAdjust).toFixed(2)}</th>
                <th></th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div className="row mt-4">
        <div
          style={{
            backgroundColor: "rgba(125, 227, 88, 0.16)",
            alignItems: "center",
            paddingTop: "5px",
          }}
        >
          <h3>
            <span style={{ color: "green" }}>|</span> Total Net Payable: ₹
            {netPay} Indian Rupee - {convertRupeesToWords(netPay)}
          </h3>
        </div>
        <div className="col">
          <p className="mt-2 text-muted">
            <p>**Total Net Payable = Gross Earnings - Total Deductions</p>
          </p>
        </div>
      </div>
      <div className="text-center mt-5">
        <p className="text-muted">
          &mdash; This is a system-generated document. &mdash;
        </p>
      </div>
    </div>
  );
};

export default SalaryBreakDown;
